/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { breakpoints } from '@airwallex/global';
import { Headline, Body } from '@airwallex/typography';
import { useTranslation } from 'react-i18next';
import { LinkInfoData } from './types';
import { headlineCss, descriptionCss } from './styles';

type Props = {
  linkInfo?: LinkInfoData;
};

export const MerchantInfo: React.FC<Props> = ({ linkInfo }) => {
  const { t } = useTranslation();
  return (
    <Body
      variant="100.Bold"
      css={css`
        ${headlineCss} margin-top: 40px;
        ${breakpoints.breakpoint.s} {
          margin-top: 24px;
        }
      `}
    >{`${t('pay_by_link.merchant_from')} ${linkInfo?.merchant}`}</Body>
  );
};

export const Title: React.FC<Props> = ({ linkInfo }) => {
  return (
    <Headline variant="100" css={headlineCss}>
      {linkInfo?.title}
    </Headline>
  );
};

export const Description: React.FC<Props> = ({ linkInfo }) => <Body css={descriptionCss}>{linkInfo?.description}</Body>;
